__turbopack_context__.v({
  "card": "SorteosPortal-module__Zx1p_a__card",
  "cardMeta": "SorteosPortal-module__Zx1p_a__cardMeta",
  "cardPrize": "SorteosPortal-module__Zx1p_a__cardPrize",
  "cardTitle": "SorteosPortal-module__Zx1p_a__cardTitle",
  "cardTop": "SorteosPortal-module__Zx1p_a__cardTop",
  "countdown": "SorteosPortal-module__Zx1p_a__countdown",
  "detail": "SorteosPortal-module__Zx1p_a__detail",
  "evidence": "SorteosPortal-module__Zx1p_a__evidence",
  "grid": "SorteosPortal-module__Zx1p_a__grid",
  "metrics": "SorteosPortal-module__Zx1p_a__metrics",
  "muted": "SorteosPortal-module__Zx1p_a__muted",
  "page": "SorteosPortal-module__Zx1p_a__page",
  "panel": "SorteosPortal-module__Zx1p_a__panel",
  "participants": "SorteosPortal-module__Zx1p_a__participants",
  "portal": "SorteosPortal-module__Zx1p_a__portal",
  "result": "SorteosPortal-module__Zx1p_a__result",
  "tabs": "SorteosPortal-module__Zx1p_a__tabs",
  "toolbar": "SorteosPortal-module__Zx1p_a__toolbar",
  "winner": "SorteosPortal-module__Zx1p_a__winner",
});
